module.exports = __webpack_public_path__ + "static/media/close-report.4c61b3a9.svg";